import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Foto di un articolo che scorrono: frecce, pallini, swipe col dito e frecce della tastiera.
// foto = elenco di indirizzi già completi. Con una sola foto è una foto normale.
// tastiera=false se in pagina ce ne sono più d'una; ogni = millisecondi per lo scorrimento da solo (0 = mai),
// fermo mentre ci si passa sopra col mouse.
export default function SlideFoto({ foto, alt = '', fit = 'contain', tastiera = true, ogni = 0 }) {
  const [k, setK] = useState(0);
  const [fermo, setFermo] = useState(false);
  const tocco = useRef(null);
  const n = foto.length;
  const vai = (d) => setK(i => (i + d + n) % n);

  useEffect(() => { setK(0); }, [foto.join('|')]);
  useEffect(() => {
    if (n < 2 || !ogni || fermo) return;
    const t = setInterval(() => setK(i => (i + 1) % n), ogni);
    return () => clearInterval(t);
  }, [n, ogni, fermo, k]);
  useEffect(() => {
    if (n < 2 || !tastiera) return;
    const tasto = e => { if (e.key === 'ArrowLeft') vai(-1); if (e.key === 'ArrowRight') vai(1); };
    window.addEventListener('keydown', tasto);
    return () => window.removeEventListener('keydown', tasto);
  }, [n, tastiera]);

  if (!n) return null;
  const freccia = (lato) => ({
    position: 'absolute', top: '50%', [lato]: '8px', transform: 'translateY(-50%)', width: '36px', height: '36px',
    borderRadius: '999px', border: 'none', background: 'rgba(0,0,0,.45)', color: '#fff', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  });
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden', touchAction: 'pan-y' }}
      onMouseEnter={() => setFermo(true)} onMouseLeave={() => setFermo(false)}
      onTouchStart={e => { tocco.current = e.touches[0].clientX; }}
      onTouchEnd={e => { if (tocco.current === null) return; const dx = e.changedTouches[0].clientX - tocco.current; tocco.current = null; if (Math.abs(dx) > 40) vai(dx < 0 ? 1 : -1); }}>
      <div style={{ display: 'flex', width: `${n * 100}%`, height: '100%', transform: `translateX(-${(k * 100) / n}%)`, transition: 'transform .3s ease' }}>
        {foto.map((src, i) => (
          <div key={src + i} style={{ width: `${100 / n}%`, height: '100%', flexShrink: 0 }}>
            <img src={src} alt={`${alt} ${i + 1}`} loading={i ? 'lazy' : 'eager'} style={{ width: '100%', height: '100%', objectFit: fit, display: 'block' }} />
          </div>
        ))}
      </div>
      {n > 1 && <>
        <button type="button" aria-label="Foto precedente" style={freccia('left')} onClick={e => { e.stopPropagation(); vai(-1); }}><ChevronLeft size={20} /></button>
        <button type="button" aria-label="Foto successiva" style={freccia('right')} onClick={e => { e.stopPropagation(); vai(1); }}><ChevronRight size={20} /></button>
        <div style={{ position: 'absolute', bottom: '10px', left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: '6px' }}>
          {foto.map((_, i) => (
            <button key={i} type="button" aria-label={`Foto ${i + 1}`} onClick={e => { e.stopPropagation(); setK(i); }}
              style={{ width: i === k ? '18px' : '8px', height: '8px', borderRadius: '999px', border: 'none', padding: 0, cursor: 'pointer', background: i === k ? '#F4600C' : 'rgba(0,0,0,.3)', transition: 'width .2s' }} />
          ))}
        </div>
      </>}
    </div>
  );
}
